import { render } from "./MyPlansPage.vue?vue&type=template&id=9ecc12ba&scoped=true"
import script from "./MyPlansPage.vue?vue&type=script&lang=js"
export * from "./MyPlansPage.vue?vue&type=script&lang=js"

import "./MyPlansPage.vue?vue&type=style&index=0&id=9ecc12ba&lang=scss&scoped=true"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ecc12ba"]])

export default __exports__